var _defs, _tspan, _tspan2, _tspan3, _tspan4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 450 450",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnssvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer2"
  }, /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "bold",
      fontStretch: "normal",
      fontSize: "53.3333px",
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      InkscapeFontSpecification: "'sans-serif, Bold'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      fill: "#1c1917",
      fillOpacity: 1,
      stroke: "none"
    },
    x: -250.78665,
    y: 38.079979,
    id: "text5840-8-6-2",
    transform: "rotate(-90)"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan5838-7-1-0",
    x: -250.78665,
    y: 38.079979
  }, "W"))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "bold",
      fontStretch: "normal",
      fontSize: "53.3333px",
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      InkscapeFontSpecification: "'sans-serif, Bold'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      fill: "#1c1917",
      fillOpacity: 1,
      stroke: "none"
    },
    x: 209.24001,
    y: -411.92001,
    id: "text5840-8-6",
    transform: "rotate(90)"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan5838-7-1",
    x: 209.24001,
    y: -411.92001
  }, "E"))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "bold",
      fontStretch: "normal",
      fontSize: "53.3333px",
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      InkscapeFontSpecification: "'sans-serif, Bold'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      fill: "#1c1917",
      fillOpacity: 1,
      stroke: "none"
    },
    x: -239.85332,
    y: -411.38669,
    id: "text5840-8",
    transform: "scale(-1)"
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan5838-7",
    x: -239.85332,
    y: -411.38669
  }, "S"))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "bold",
      fontStretch: "normal",
      fontSize: "53.3333px",
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      InkscapeFontSpecification: "'sans-serif, Bold'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      fill: "#dc2626",
      fillOpacity: 1,
      stroke: "none"
    },
    x: 203.32001,
    y: 38.079979,
    id: "text5840"
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan5838",
    x: 203.32001,
    y: 38.079979
  }, "N"))), /*#__PURE__*/React.createElement("g", {
    id: "g14619",
    transform: "translate(1.293336,-1.0012819)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "none",
      fillOpacity: 1,
      stroke: "#57534e",
      strokeWidth: 4,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 54.475255,226.00128 h 19.94064",
    id: "path7139"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "none",
      fillOpacity: 1,
      stroke: "#57534e",
      strokeWidth: 4,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 372.99747,226.00128 h 19.9406",
    id: "path7136"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "none",
      fillOpacity: 1,
      stroke: "#57534e",
      strokeWidth: 4,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 224.41332,375.29205 v 19.94064",
    id: "path7040-3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "none",
      fillOpacity: 1,
      stroke: "#dc2626",
      strokeWidth: 4,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 223,56.769878 v 19.94064",
    id: "path7040"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#1c1917",
      strokeWidth: 4.13936,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path3993",
    cx: -226.00128,
    cy: 223.70667,
    r: 167.16173,
    transform: "rotate(-90)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRose);
export default __webpack_public_path__ + "static/media/rose.e1fc4df7c12fcade7f66ae5c0c2a3b48.svg";
export { ForwardRef as ReactComponent };